export default __webpack_public_path__ + "static/media/devider.9a18de59.svg";